import { render, staticRenderFns } from "./Float.vue?vue&type=template&id=23317ab4&"
import script from "./Float.vue?vue&type=script&lang=js&"
export * from "./Float.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports